import {
  MODE_CALCUL_FORFAIT,
  MODE_CALCUL_POURCENTAGE,
} from '@/configuration/tiers/tiersConf';

export default function validationEditCalculHonoraire(modeCalculHonoraire, messages) {
  if (modeCalculHonoraire.modeCalcul === MODE_CALCUL_POURCENTAGE
    && !modeCalculHonoraire.applicableSurTlpe
    && !modeCalculHonoraire.applicableSurLocation) {
    messages.push({ message: 'editionClient.honoraire.popUp.errors.oneProduct' });
  }
  if (modeCalculHonoraire.modeCalcul === MODE_CALCUL_FORFAIT
    && !modeCalculHonoraire.montantForfaitHt) {
    messages.push({
      message: 'editionClient.validation.calculHonoraireForfaitAmountNull',
    });
  }
  if (modeCalculHonoraire.modeCalcul === MODE_CALCUL_POURCENTAGE
    && !modeCalculHonoraire.pourcentage) {
    messages.push({
      message: 'editionClient.validation.calculHonorairePercentNull',
    });
  }
}
